import { useAcl } from "vue-simple-acl";
import { ACLRoles } from "~/core/models/ACLRoles.enum";

const { can } = useAcl();

export function canViewMobileApplication() {
  return can(ACLRoles.CAN_READ_APPLICATION);
}
